<template>
    <Menu as="div" class="relative inline-block text-left">
      <div>
        <MenuButton class="font-bold text-[18px] text-black flex items-center gap-[6px]">
          <slot name="title"></slot>
          <IconArrowLeft/>
        </MenuButton>
      </div>

      <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
        <MenuItems
        class="absolute flex flex-col sm:flex-row justify-center z-50 mt-2 origin-top-right divide-x divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none whitespace-nowrap">
          <div class="py-1">
            <MenuItem v-slot="{ active }" v-for="item in firstColumn" :key="item.id">
            <router-link :to="{ name: routeName, query: { category: item.id } }"  class="font-normal text-gray-700 block px-4 py-2 text-sm hover:text-accent-color">{{
              item.name }} <span v-if="item.objects__count > 0" class="text-red-500">{{ item.objects__count }}</span></router-link>
            </MenuItem>
          </div>
          <div class="py-1">
              <MenuItem v-slot="{ active }" v-for="item in secondColumn" :key="item.id">
                <router-link :to="{ name: routeName, query: { category: item.id } }" class="font-normal text-gray-700 block px-4 py-2 text-sm hover:text-accent-color">{{item.name}} <span v-if="item.objects__count > 0" class="text-red-500">{{ item.objects__count }}</span></router-link>
              </MenuItem>
            </div>
          <div class="py-1">
              <MenuItem v-slot="{ active }" v-for="item in thirdColumn" :key="item.id">
                <router-link :to="{ name: routeName, query: { category: item.id } }"  class="font-normal text-gray-700 block px-4 py-2 text-sm hover:text-accent-color">{{item.name}} <span v-if="item.objects__count > 0" class="text-red-500">{{ item.objects__count }}</span></router-link>
              </MenuItem>
            </div>
        </MenuItems>
      </transition>
    </Menu>
  </template>
    
  <script>
  import IconArrowLeft from '@icons/IconArrowLeft.vue'
  import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
  
  
  export default {
    props: {
      content: {
        type: Array,
        required: true
      },
      routeName: {
        type: String,
        default: 'publications'
      }
    },
    components: {
      Menu, MenuButton, MenuItem, MenuItems, IconArrowLeft
    },
    data() {
      return {

      };
    },
    mounted() {
    },
    computed: {
      midpoint(){
        return Math.ceil(this.content.length / 3);
      },
      firstColumn(){
        return  this.content.slice(0, this.midpoint);
      },
      secondColumn(){
        return this.content.slice(this.midpoint, 2 * this.midpoint);
      },
      thirdColumn(){
        return this.content.slice(2 * this.midpoint);
      },
    },
    methods: {
       
      handleCategoryClick(categoryId) {
        this.$router.push({ name: 'publications', query: { category: categoryId } });
      },
    }
  };
  
  </script>